export default {
  name: "production",
  api: {
    baseUrl: "https://api.layapp.jp",
  },
};
